// constant
import { FILE_UPLOAD_CONSTANT } from "constants/global";

export const getFileList = (info: any) => {
	let list = [...info.fileList];
	list = list.map((file) => {
		if (file.type === "" && file.name.endsWith(FILE_UPLOAD_CONSTANT.FILETYPE_MSG)) {
			file["type"] = FILE_UPLOAD_CONSTANT.FILETYPE_VND_MS_OUTLOOK;
			return file;
		} else {
			return file;
		}
	});
	return list;
};
